import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})
export class AppointmentsService {

  constructor(private http: HttpClient) { }

  public getAppointment(id: number): Observable<any> {
    return this.http.get(`${BASEURL}/appointments/${id}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        // catchError(this.handleError<any>('login', []))
      );
  }

  public getAppointments(start: Date, end: Date): Observable<any> {
    // agregar parametros start y end

    return this.http.get(`${BASEURL}/v2/appointments`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      params: {
        start_date: start.toISOString(),
        end_date: end.toISOString()
      }
    }).pipe(
      tap((response: any) => {
        // Manejo de la respuesta, como loguearla o procesarla
      }),
      // Manejo de errores si es necesario
      // catchError(this.handleError<any>('getAppointments', []))
    );
  }

  getNextAppointments(): Observable<any> {
    return this.http.get(`${BASEURL}/users/next_appointments`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
        // Manejo de la respuesta, como loguearla o procesarla
      }),
      // Manejo de errores si es necesario
      // catchError(this.handleError<any>('getNextAppointments', []))
    );
  }

  public getLastBlockedSlots(): Observable<any> {
    return this.http.get(`${BASEURL}/v3/last_20_blocked_slots`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
        // Manejo de la respuesta, como loguearla o procesarla
      }),
      // Manejo de errores si es necesario
      // catchError(this.handleError<any>('getAppointments', []))
    );
  }
  

  public getBlockedSlots(start: Date, end: Date): Observable<any> {
    return this.http.get(`${BASEURL}/v3/blocked_slots`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      params: {
        start_date: start.toISOString(),
        end_date: end.toISOString()
      }
    }).pipe(
      tap((response: any) => {
        // Manejo de la respuesta, como loguearla o procesarla
      }),
      // Manejo de errores si es necesario
      // catchError(this.handleError<any>('getAppointments', []))
    );
  }

  public saveBlockedSlot(data: any): Observable<any> {
    return this.http.post(`${BASEURL}/v3/blocked_slots`, data, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        // catchError(this.handleError<any>('login', []))
      );
  }

  public deleteBlockedDate(id: number): Observable<any> {
    return this.http.delete(`${BASEURL}/v3/blocked_slots/${id}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        // catchError(this.handleError<any>('login', []))
      );
  }

  public cancelAppointment(id: number): Observable<any> {
    return this.http.put(`${BASEURL}/appointments/${id}/cancel`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        // catchError(this.handleError<any>('login', []))
      );
  }
}
